import { createFileRoute } from '@tanstack/react-router';

import { BitacoraPage } from '@/features/tasks/components/bitacora/bitacora-page';

export const Route = createFileRoute('/_app/tasks/bitacora')({
  component: BitacoraPage,
});
